// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nspan[data-v-7780c8c8] {\n  color: #666;\n}\n", ""]);
// Exports
module.exports = exports;
